import { useI18n } from '@haohan/root-locales';
import { Box, Container, Link, Typography } from "@mui/material";
import { blue, blueGrey,  } from "@mui/material/colors";
import { makeStyles } from "tss-react/mui";
import { SiteLanguages } from '../../app/Languages';

const useStyles = makeStyles()(theme => {
    return {
        root: {
            fontSize: 14,
            backgroundColor: blueGrey[900],
            // backgroundColor: blueGrey[50],
            color: 'white',
            padding: '12px 16px'
        }
    };
})

export const SiteFooter = () => {
    const { classes } = useStyles();
    const { t } = useI18n();
    const now = new Date();
    return (
        <footer className={classes.root}>
            <Container maxWidth='lg'>
                <Box
                    display='flex'
                    justifyContent='space-between'
                    alignItems='center'
                >
                    <Box>
                        <Box>
                            © {now.getFullYear()} haohan.io
                        </Box>
                        <Box>
                            Icons from{' '}
                            <Link
                                color='inherit'
                                href='https://icons8.com'
                                target='_blank'>
                                icons8.com
                            </Link>
                        </Box>
                    </Box>
                    <Box display='flex' alignItems='center'>
                        <Typography mr={1} variant='body2' fontWeight='bold'>
                            {t("Language")}
                        </Typography>
                        <SiteLanguages />
                    </Box>
                </Box>
            </Container>
        </footer>
    );
}
